import { createApp } from 'vue'
import Sitemap from './SiteMap.vue'
import router from "@/router/mobileMenu.router";

createApp(Sitemap).use(router).mount('#sitemap')
